/* ── Scroll progress bar + header scroll state ── */
const bar = document.getElementById('progress-bar');
const siteHeader = document.getElementById('site-header');
window.addEventListener('scroll', () => {
  const s = document.documentElement;
  const pct = (s.scrollTop / (s.scrollHeight - s.clientHeight)) * 100;
  bar.style.width = pct + '%';
  siteHeader && siteHeader.classList.toggle('scrolled', s.scrollTop > 60);
}, { passive: true });

/* ── Back to top ── */
const btn = document.getElementById('back-to-top');
window.addEventListener('scroll', () => {
  btn.classList.toggle('visible', window.scrollY > 600);
}, { passive: true });

/* ── Scroll reveal (Intersection Observer) ── */
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

/* ── Rotating topbar messages ── */
const msgs = document.querySelectorAll('.topbar-msg');
let cur = 0;
if (msgs.length > 1) {
  setInterval(() => {
    msgs[cur].classList.remove('active');
    cur = (cur + 1) % msgs.length;
    msgs[cur].classList.add('active');
  }, 3600);
}

/* ── Marquee pause on hover ── */
const track = document.querySelector('.marquee-track');
if (track) {
  track.addEventListener('mouseenter', () => track.style.animationPlayState = 'paused');
  track.addEventListener('mouseleave', () => track.style.animationPlayState = 'running');
}

/* ── Testimonials scroll nav ── */
(function() {
  const scroll = document.getElementById('testi-scroll');
  const dots   = document.querySelectorAll('.testi-dot');
  if (!scroll) return;

  function cardWidth() {
    const card = scroll.querySelector('.testi-card');
    if (!card) return 380;
    return card.offsetWidth + 24; // width + gap
  }

  function updateDots() {
    const idx = Math.round(scroll.scrollLeft / cardWidth());
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      scroll.scrollTo({ left: i * cardWidth(), behavior: 'smooth' });
    });
  });

  const prev = document.getElementById('testi-prev');
  const next = document.getElementById('testi-next');
  if (prev && next) {
    prev.addEventListener('click', () => scroll.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
    next.addEventListener('click', () => scroll.scrollBy({ left:  cardWidth(), behavior: 'smooth' }));
  }
  scroll.addEventListener('scroll', updateDots, { passive: true });
})();

/* ── Instagram scroll nav ── */
(function() {
  const scroll = document.getElementById('insta-scroll');
  const dots   = document.querySelectorAll('.insta-dot');
  const CARD   = 328 + 24; // width + gap

  function updateDots() {
    const idx = Math.round(scroll.scrollLeft / CARD);
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  const prev = document.getElementById('insta-prev');
  const next = document.getElementById('insta-next');
  if (prev && next && scroll) {
    prev.addEventListener('click', () => scroll.scrollBy({ left: -CARD, behavior: 'smooth' }));
    next.addEventListener('click', () => scroll.scrollBy({ left:  CARD, behavior: 'smooth' }));
    scroll.addEventListener('scroll', updateDots, { passive: true });
  }
})();

/* ── Zari needle ── */
(function() {
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  const track  = document.getElementById('zari-track');
  const needle = document.getElementById('zari-needle');
  if (!track || !needle) return;

  const KNOT_PCTS = [0.2, 0.42, 0.63, 0.82];
  const PAD = 72;

  function trackY(pct) {
    return PAD + pct * (window.innerHeight - PAD * 2);
  }

  const knots = KNOT_PCTS.map(pct => {
    const el = document.createElement('div');
    el.className = 'zari-knot';
    document.body.appendChild(el);
    return { el, pct };
  });

  function positionKnots() {
    knots.forEach(({ el, pct }) => {
      el.style.top = (trackY(pct) - 3.5) + 'px';
    });
  }
  positionKnots();
  window.addEventListener('resize', positionKnots);

  let lastScroll = -1;
  function update() {
    const scrolled = window.scrollY;
    if (scrolled === lastScroll) return;
    lastScroll = scrolled;

    const total = document.documentElement.scrollHeight - window.innerHeight;
    const pct   = total > 0 ? Math.min(scrolled / total, 1) : 0;

    needle.style.top = (trackY(pct) - 15) + 'px';

    const show = scrolled > 120;
    track.classList.toggle('zari-show', show);
    needle.classList.toggle('zari-show', show);
    knots.forEach(({ el, pct: kp }) => {
      el.classList.toggle('zari-show', show);
      el.classList.toggle('zari-passed', pct >= kp);
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
